import { Component, OnInit, HostListener, Renderer2, ViewChild, ElementRef, AfterViewInit, ViewChildren, QueryList, Injectable, ChangeDetectorRef, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { ScrollService } from 'src/app/shared/services/Scroll/scroll.service';
import { CartService } from 'src/app/shared/services/Cart/cart.service';
import { DOCUMENT } from '@angular/common';
import { SharedService } from 'src/app/shared/services/shared/shared.service';
import { EventsService } from 'src/app/shared/services/events/events.service';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { Categorias, Company, typeInterface } from 'src/app/shared/Interfaces/company';
import { ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { Fidelity } from 'src/app/shared/Interfaces/fidelity';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { PixelService } from 'src/app/shared/services/pixel.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
@Injectable({
  providedIn: 'root'
})

export class MenuComponent implements OnInit, AfterViewInit{

  //#region Variaveis de Elementos HTML
    @ViewChildren('sections') sections!: QueryList<ElementRef>;
    @ViewChild('sections', { read: ElementRef }) sectionsRefs: ElementRef[] = [];
  //#endregion

  //#region Variaveis de estilo
    verifiScrolling = false;
    backgroundLoad = false;
    showSideBar = true;
    emptyProduct = false;
    showInput!: boolean;
    openModalTwo = false;
    readOnlyState: boolean = false;
    darkTheme = this.cacheService.getItemLocal('dark-theme')
  //#endregion

  //#region Variaveis locais
    private verificationRequest = false;
    typeParam!: typeInterface;
    private scrollTopPosition: number = 0;
    private positions!: ElementRef[];
    statusCompany = false;
    nameCompany: string = '';
    nameEmpresa!: string;
    imgLogo!: string;
    imgBackground!: string;
    local: boolean = false;
    nameStatusCompany!: string;
    filter: string = '';
    counterCart: number = 0;
    tabela!: Categorias[];
    company!: Company;
    user!: Cliente;
    fidelity!: Fidelity;
    isMobile: boolean = false;
    isTablet: boolean = false;
    isDesktop: boolean = false;
    imgsLoadead!: boolean[];

  //#endregion

  //#region Inicializadores
    constructor(
      private router: Router,
      private cacheService: CacheService,
      private scrollService: ScrollService,
      private cartService: CartService,
      private connection: ConnectionService,
      private renderer: Renderer2,
      private sharedService: SharedService,
      private eventService: EventsService,
      @Inject(DOCUMENT) private document: Document,
      private pixelService: PixelService,
      private titleService: Title,
      private metaService: Meta,
      private cdr: ChangeDetectorRef
      )
      {
        this.cartService.counter$.subscribe(newCount => {
          this.counterCart = newCount;
        });

        this.connection.nameCompany$.subscribe((newNameCompany: string) => {
          this.nameCompany = newNameCompany;
        });

        this.connection.readOnlyState$.subscribe((data) =>{
          this.readOnlyState = data;
        })

        this.connection.typeParam$.subscribe((newTypeParam) => {
          this.typeParam = newTypeParam
          
          if(this.typeParam.type == 0 || this.typeParam.type == 3){
            this.local = false;
          }
          else{
            this.local = true
          }
        });

        this.connection.verificationRequest$.subscribe((newValue) =>{
          this.verificationRequest = newValue
        });

        this.scrollService.scrolling$.subscribe((scrolling) =>{
          this.verifiScrolling = scrolling;
        });

        this.connection.fidelity$.subscribe(
          (data)=>{
            this.fidelity = data
          }
        );

        this.connection.user$.subscribe((User) =>{
          this.user = User;
        });

        this.sharedService.filter$.subscribe((newValue) =>{
          this.filter = newValue
          if(this.filter != ''){
            this.showInput = true;
          }
        });

        this.connection.company$.subscribe((newValue) =>{
          if(newValue)
          {
            setTimeout(() => {
              this.company = newValue;
              this.tabela = this.company.categories;
              this.nameEmpresa = this.company.company.companyName.toUpperCase()
              this.imgLogo = this.company.company.logo;
              this.imgBackground = this.company.company.background;

              this.verifiStatusCompany();
              this.updateMetaTags();
              this.loadImages();

              this.cdr.detectChanges();
            })
          }
          
        })
      }

    ngOnInit(){
      //Busca as informações da empresa
      this.getStore();

      //Altera o padding de acordo com o tamanho da tela
      this.alterationLayout();

      //Exibe ou esconde a barra lateral
      this.toggleSideBar();

      //Resgata os produtos no carrinho
      this.cartService.getCartItems();

      //Resgata as posições das categorias
      this.resgataPosition();

      if(this.verificationRequest)
      {
        this.backgroundLoad = true;
      }
    }

    ngAfterViewInit(){
      //Envia o evento Pixel
      setTimeout(() => {
        this.sendEvent();
      }, 2000);

    }

    ngOnDestroy(){}

  //#endregion

  //#region Funções de estilo (Style)

    //Monta a lógica para o carregamento parcial
    loadImages(){
      let value = 0
      this.tabela.forEach(category => {
        value += category.products.length
      });

      this.imgsLoadead = Array(value).fill(false);
    }

    //Exibe ou esconde a barra lateral
    toggleSideBar(){
      if(window.innerWidth < 1169){
        this.showSideBar = false
      }
      else {
        this.showSideBar = true;
      }
    }

    //Deasabilitao scroll da pagina
    disableScroll(){
      this.renderer.setStyle(this.document.body, 'overflow', 'hidden')
    }

    //Abilita o scroll da pagina
    enableScroll(){
      this.renderer.removeStyle(this.document.body, 'overflow');
    }

    //resgata a posição das sections, para que a side-bar possa usar
    resgataPosition(){
      this.positions = [];
      if(this.sections){
        this.sections.forEach((element: ElementRef) =>{
          this.positions.push(element)
        });
        this.scrollService.loadSections(this.positions);
      }
      this.cdr.detectChanges();
    }

    //Altera o layout da aplicação
    alterationLayout(){
      this.scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      //Mobile
      if(window.innerWidth <= 846)
      {
        this.isTablet = false;
        this.isDesktop = false;
        this.isMobile = true;
      }
      //Tablet
      else if(window.innerWidth >= 846 && window.innerWidth <= 1168)
      {
        this.isMobile = false;
        this.isDesktop = false;
        this.isTablet = true;  
      }
      //Desktop
      else{
        this.isDesktop = true;
        this.isMobile = false;
        this.isTablet = false;
      }
    }

    //Quando as imagens dos produtos são carregadas
    loadImgComplete(event: Event, index: number){
      const element = event.target as HTMLImageElement;

      this.imgsLoadead[index] = true;
      this.renderer.addClass(element, 'complete')

    }

    //Quando o background é carregado
    loadBackground(){
      if(!this.verificationRequest)
      {
        setTimeout(() => {
          this.backgroundLoad = true;
        }, 500);
      }
      else{
        this.backgroundLoad = true;
      }

    }

  //#region Chamadas de eventos da tela
    @HostListener('window:resize', [])
    onResize(){
      this.alterationLayout();
      if(window.innerWidth < 1169){
        this.showSideBar = false
      }
      else {
        this.showSideBar = true;
      }

    }

    @HostListener('window:scroll', ['$event'])
    onScroll(): boolean  {
      this.alterationLayout();
      
      return false;
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event: PopStateEvent): void {
      event.preventDefault();
      this.enableScroll();
    }

    //Atualiza o titulo da pagina
    updateMetaTags() {
      this.titleService.setTitle(`${this.company.company.companyName} - Pedeaqui`);
      
      this.metaService.addTags([
        { property: 'og:title', content: `${this.company.company.companyName} - Pedeaqui`},
      ]);
    }

    getHeight(): string | null {
      const closeScheduling = this.company?.configs?.closeScheduling === 1;
      if (closeScheduling && this.isMobile && !this.readOnlyState && !this.local) {
        return '340px';
      }

      if (this.isMobile && !this.readOnlyState && !this.local) {
        return '305px';
      }

      if (this.readOnlyState || this.local) {
        return '265px';
      }

      return null;
    }

  //#endregion

  //#endregion

  //#region Funções de Lógica (Logic)

    //captura a id do elemento clicado e redireciona para rota do detalhe do produto
    capturaId(id: number, indexSection: number){
      if(this.nameCompany == '')
      {
        this.connection.nameCompany$.subscribe({
          next: (newNameCompany: string) => {
            console.log('Novo nome da empresa recebido:', newNameCompany);
          },
          error: (error) => {
            console.error('Erro ao receber nome da empresa:', error);
          },
          complete: () => {
            console.log('Completado');
          }
        });

        if(this.nameCompany == '')
        {
          this.nameCompany = this.cacheService.getItemLocal('name_cache_key')
        }
      }

      this.eventService.eventFilterSubject.next(true);
      this.router.navigate([this.nameCompany, 'product-detail', id])

    }

    getStore(){
      if(!this.verificationRequest)
      {
        this.connection.getCompany(this.nameCompany, this.typeParam.type).subscribe((data) =>{});
      }
    }

    //Verifica se a loja esta fechada ou aberta
    verifiStatusCompany(){
      if(this.company.company.status == 0)
      {
        this.nameStatusCompany = 'Loja Fechada';
        this.statusCompany = false;
      }
      else if(this.company.company.status == 1)
      {
        this.nameStatusCompany = 'Loja Aberta';
        this.statusCompany = true;
      }
    }

    //Envia o evento de ViewContent para meta
    sendEvent(){
      this.pixelService.trackViewContent({
        content_name: 'Cardápio Digital',
        content_ids: '',
        content_type: 'product_group',
        value: 0,
        currency: 'BRL',
        eventref: this.pixelService.getEventRef() || '',
      })
    }

  //#endregion

  }
